//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import countries from './countryList'
 export default {
    components: {  
    },
    data() {
       return { 
        countriesFind: {},
        selectIndex: 0,
        isShow: false
       }
    },
      created() {
        const lang = window.localStorage.getItem("lang") || 'en'
         this.countriesFind = countries[lang]
         console.log(this.countriesFind)
        // let us = countries['zh'];
        // console.log(us)
      },
      computed:{
      
      },    
      methods: {
        open ()  {
            this.isShow = true;
        },
        selectItem(item, key) {
            this.selectIndex = item.code;
            let obj = {
                name: item.name,
                code: item.code,
                dialCode: item.dialCode,
                key: key
            }

            this.$emit('getName', obj)
            this.isShow = false
        }
      }
   }
 


// WEBPACK FOOTER //
// ./src/components/areaList.vue